import "@/plugins/VeeValidate";
import "@/plugins/moment";
import "@/plugins/lodash";
import "@/plugins/vClickOutside";
import buildAxios from '@/plugins/axios';

buildAxios();
